
import React from "react";
import ReactDOM from 'react-dom';
import Playlist from '../Playlist';
import { sendArtworks, getMuteFlag, getQualityFlag, getOffset, storeOffset, sendPlaylists } from '../../pages/utils.js'
import "./selected-carousel.scss";
import store from 'store';
import { connect } from "react-redux";
import { fetchArtworksCollection } from '../../actions/playlistActions';

export default class SelectedPlaylistCarousel extends React.Component {
  constructor(props) {
    super(props);
    const playlist = props.playlist ? props.playlist : [];
    this.state = {
      //current: 2,
      current: playlist ? parseInt(playlist.length / 2) : 0,
      show: false,
      playlists: playlist,
      playlistName: playlist.name,
      artNo: 2,
      highquality: "high",
      mute: "false",
      firstPlaylist: 0,
    }
    this.offset = getOffset() || 0;
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

componentWillReceiveProps(nextProps) {
  const { playlist } = nextProps;
if(this.state.playlists == playlist) {
  return;
}
  // this.state = {
  //   current: 2,
  //   playlists: playlist
  // }

  // setTimeout(() => {
  //   this.setOtherList();
  //   this.setList();
  // }, 10);
}

  componentDidMount() {
    this.setList();
    this.checkQuality();
    this.setState({
      mute: getMuteFlag() || "false",
    })
  }

  componentWillUnmount() {
    storeOffset(this.offset);
  }

  componentDidUpdate() {
    this.setList();
  }

 
setList() {
  let { current, playlists } = this.state;
  if (current == playlists.length - 1 || current == playlists.length - 2) {
    var newArray = this.state.playlists.slice();
    for (let i = 0; i < playlists.length; i++) {
      newArray.push(playlists[i]);
      this.setState({
        playlists: newArray
      })
    }
  }
}

  checkQuality() {
    if (getQualityFlag()) {
      this.setState({
        highquality: "4k"
      })
    }
    else {
      this.setState({
        highquality: "high"
      })
    }
  }

  getArtworkFromPlaylist() {
    const user = store.get('auth__user');
    const id = user.id ? user.id : user;
    const pid = this.state.playlists[this.state.current].id;
    const { dispatch } = this.props;
    fetchArtworksCollection(dispatch, id, pid);
    store.set('featured','featured');
  }

  handleKeyDown(e) {
    let isSubscribed = store.get('subscription') == "no" ? "false" : "true" || "false";
    switch (e.which) {
      case 13:
          this.getArtworkFromPlaylist();
        // sendArtworks(this.state.artworks, this.state.playlistName, this.state.highquality, getMuteFlag() || "false", "false", this.state.current, "true", isSubscribed);
        break;
      case 37:
        this.prev();
        break;
      case 39:
        this.next();
        break;
    }
  }
  handleClick() {
    // this.getArtworkFromPlaylist();
  }



next() {
  this.setState({
    transition: false,
    artNo: 2
  })
  // let { current } = this.state;
  const { playlists } = this.state;
  // current += 1;
  // if (current == playlists.length - 3 || current == playlists.length - 2 || current == playlists.length - 1 || current == playlists.length) {
    var newArray = this.state.playlists.slice(0);
    // for (let i = 0; i < playlists.length; i++) {
      newArray.push(newArray.shift());
      this.setState({
        playlists: newArray
      })
    // }

  // }
  // this.setState({ current });
}

prev() {
  const slides = this.state.playlists.slice(0);
    slides.unshift(slides.pop());
    this.setState({playlists:slides});
  // this.setState({
  //   transition: false,
  //   artNo: 1
  // })
  // let { current } = this.state;
  // const { playlists } = this.state;
  // current -= 1;
  // let k = playlists.length;
  // if (current == 1 || current == 0) {
  //   var newArray = this.state.playlists.slice();
  //   for (let i = k - 1; i >= 0; i--) {
  //     newArray.unshift(playlists[i]);
  //     this.setState({
  //       playlists: newArray
  //     })
  //     current++;
  //   }
  // }
  // this.setState({ current });
}

setOtherList() {
  let { current, playlists } = this.state;
  let k = playlists.length;
  var newArray1 = this.state.playlists.slice();
  for (let i = k - 1; i >= 0; i--) {
    newArray1.unshift(playlists[i]);
    this.setState({
      playlists: newArray1
    })
    current++;
  }
  this.setState({ current });
}

render() {
  const { current, artNo } = this.state;
  const { playlists } = this.state || {};

  if (!playlists) {
    return null
  }
  let left = (- (current * 22) + 14.5);
  const slides = playlists.map((item, idx) => {
    left += 22;
    return (
      <div key="idx" className="selected-carousel__slide" style={{ left: `${left}%` }}>
        <Playlist key={idx} showDetails={idx == current && this.state.show} playlist={item} showImage={artNo == 2 ? idx >= current - 4 && idx <= current + 3 : idx >= current - 3 && idx <= current + 3} />
      </div>
    );
  });

  return (
    <div
      tabIndex="2"
      className="selected-carousel"
      ref="selectedcarousel"
      onKeyDown={this.handleKeyDown}
      onClick={this.handleClick}
      onFocus={() => this.setState({ show: true })}
      onBlur={() => this.setState({ show: false })}
    >
      {slides}
    </div>
  );
}
}
